/**
 * Internationalization (i18n) Configuration
 * Supports multiple African languages including Ghana local languages
 */

import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

// Import translations
import en from '../locales/en/translation.json'
import tw from '../locales/tw/translation.json'
import gaa from '../locales/gaa/translation.json'
import ee from '../locales/ee/translation.json'
import dag from '../locales/dag/translation.json'
import fat from '../locales/fat/translation.json'
import sw from '../locales/sw/translation.json'
import fr from '../locales/fr/translation.json'
import pt from '../locales/pt/translation.json'
import ha from '../locales/ha/translation.json'
import yo from '../locales/yo/translation.json'
import ig from '../locales/ig/translation.json'

// Translation resources
const resources = {
  en: { translation: en },
  tw: { translation: tw },
  gaa: { translation: gaa },
  ee: { translation: ee },
  dag: { translation: dag },
  fat: { translation: fat },
  sw: { translation: sw },
  fr: { translation: fr },
  pt: { translation: pt },
  ha: { translation: ha },
  yo: { translation: yo },
  ig: { translation: ig },
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,

    interpolation: {
      escapeValue: false, // React already escapes
    },

    // Detection options
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  })

export default i18n

// Language metadata for UI
export const SUPPORTED_LANGUAGES = [
  // Ghana Languages
  { code: 'tw', name: 'Twi (Akan)', nativeName: 'Twi', flag: '🇬🇭', region: 'Ghana' },
  { code: 'gaa', name: 'Ga', nativeName: 'Gã', flag: '🇬🇭', region: 'Ghana' },
  { code: 'ee', name: 'Ewe', nativeName: 'Eʋegbe', flag: '🇬🇭', region: 'Ghana' },
  { code: 'dag', name: 'Dagbani', nativeName: 'Dagbanli', flag: '🇬🇭', region: 'Ghana' },
  { code: 'fat', name: 'Fante', nativeName: 'Fante', flag: '🇬🇭', region: 'Ghana' },

  // West African Languages
  { code: 'ha', name: 'Hausa', nativeName: 'Hausa', flag: '🇳🇬', region: 'West Africa' },
  { code: 'yo', name: 'Yoruba', nativeName: 'Yorùbá', flag: '🇳🇬', region: 'West Africa' },
  { code: 'ig', name: 'Igbo', nativeName: 'Igbo', flag: '🇳🇬', region: 'West Africa' },

  // East African Languages
  { code: 'sw', name: 'Swahili', nativeName: 'Kiswahili', flag: '🇰🇪', region: 'East Africa' },

  // International Languages
  { code: 'en', name: 'English', nativeName: 'English', flag: '🇬🇧', region: 'International' },
  { code: 'fr', name: 'French', nativeName: 'Français', flag: '🇫🇷', region: 'International' },
  { code: 'pt', name: 'Portuguese', nativeName: 'Português', flag: '🇵🇹', region: 'International' },
]
